import React from 'react';

const PolicyText: React.FC = () => {
    return (
        <div className="text-gray-300 space-y-6 text-xs md:text-sm tracking-wide leading-relaxed">
            <h3 className="font-bold text-[#00d4ff] uppercase tracking-widest mb-4 border-b border-white/10 pb-3 text-lg">Política de Cancelación y Reprogramación</h3>
            <p className="italic text-gray-400">Entendemos que los planes pueden cambiar, pero nuestra logística se activa con antelación:</p>
            
            <div className="space-y-3 mt-6 text-left">
                <h4 className="text-white font-bold uppercase text-[10px] md:text-xs tracking-[0.2em] border-l-2 border-[#00d4ff] pl-3">Cancelación por parte del Cliente:</h4>
                <ul className="list-disc pl-6 space-y-2 text-gray-400 marker:text-[#00d4ff]">
                    <li><strong className="text-gray-200">72 horas o más:</strong> Devolución del 100% de la reserva (o reprogramación sujeta a disponibilidad).</li>
                    <li><strong className="text-gray-200">Entre 48 y 24 horas antes:</strong> Devolución del 50% del valor total (por costos operativos y reserva de guía).</li>
                    <li><strong className="text-gray-200">Menos de 24 horas o "No Show":</strong> No hay devolución.</li>
                </ul>
            </div>

            <div className="space-y-3 mt-6 text-left">
                <h4 className="text-white font-bold uppercase text-[10px] md:text-xs tracking-[0.2em] border-l-2 border-[#00d4ff] pl-3">Cancelación por Clima o Fuerza Mayor:</h4>
                <p className="text-gray-400 pl-4">
                    Si el guía determina que la zona de expedición no es segura antes de salir, se ofrecerá una actividad alternativa, reprogramación o la devolución del 80% del pago <span className="text-[10px] text-gray-500 block mt-1">(el 20% se retiene por gastos administrativos)</span>.
                </p>
            </div>

            <div className="bg-stone/60 border border-rock p-5 md:p-6 mt-8 text-left space-y-4 shadow-inner">
                <div>
                    <strong className="text-[#00d4ff] uppercase text-[10px] tracking-[0.2em] block mb-1">■ Declaración de Salud:</strong>
                    <p className="text-gray-400 text-xs">El cliente debe informar sobre lesiones previas, asma, problemas cardíacos o alergias severas al momento de reservar.</p>
                </div>
            </div>
        </div>
    );
};

export default PolicyText;
